export enum InputType {
  Text = 'text',
  Price = 'price',
  Language = 'language',
  Hidden = 'hidden',
  Password = 'password',
  PasswordConfirmation = 'password_confirmation',
  Radio = 'radio',
  Select = 'select',
  CustomSelect = 'custom_select',
  Checkbox = 'checkbox',
  Combobox = 'combobox',
  Date = 'date',
  File = 'file',
  DragAndDropImage = 'drag_and_drop_image',
  DragAndDropVideo = 'drag_and_drop_video',
  Slider = 'slider',
  DateMonth = 'date_month',
  DateTime = 'date_time',
  DateRange = 'date_range',
  DateRangeTime = 'date_range_time',
  DateRangeOneField = 'date_range_one_field',
  Autocomplete = 'autocomplete',
  Textarea = 'textarea',
  RichText = 'richtext',
  Decimal = 'decimal',
  ColorPicker = 'color_picker',
}
